"use client"

import { ModelShowcaseDto } from "api"
import { useEffect, useState } from "react"
import SwiperCore from "swiper"
import ModelDetails from "./ModelDetails"
import ModelHeader from "./ModelHeader"
import ModelImageSwiper from "./ModelImageSwiper"
import NavArrow from "./NavArrow"
import {
  ArrowSlot,
  CarouselArea,
  Eyebrow,
  Foot,
  Headline,
  SecHead,
  Section,
} from "./modelShowcase.styled"

const EYEBROW = "THE ALL MAZDA"

type Props = { data?: ModelShowcaseDto | null }

const ModelShowcase = ({ data }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [swiper, setSwiper] = useState<SwiperCore | null>(null)

  const models = data?.models ?? []

  useEffect(() => {
    setActiveIndex(0)
  }, [data?.models])
  if (models.length === 0) return null

  const activeModel = models[activeIndex] ?? models[0]
  const showArrows = models.length > 1

  return (
    <Section dir="rtl" aria-label={data?.sectionHeadline || "Model Showcase"}>
      <SecHead>
        <Eyebrow>{EYEBROW}</Eyebrow>
        {data?.sectionHeadline && <Headline dir="auto">{data.sectionHeadline}</Headline>}
      </SecHead>

      <CarouselArea>
        <ModelHeader model={activeModel} />
        <ModelImageSwiper
          models={models}
          onActiveIndexChange={setActiveIndex}
          onSwiper={setSwiper}
        />
        {showArrows && (
          <>
            <ArrowSlot $side="right">
              <NavArrow direction="prev" ariaLabel="הדגם הקודם" onClick={() => swiper?.slidePrev()} />
            </ArrowSlot>
            <ArrowSlot $side="left">
              <NavArrow direction="next" ariaLabel="הדגם הבא" onClick={() => swiper?.slideNext()} />
            </ArrowSlot>
          </>
        )}
      </CarouselArea>

      <Foot>
        <ModelDetails model={activeModel} />
      </Foot>
    </Section>
  )
}

export default ModelShowcase
